import SEOHead from '../components/SEOHead';
import './Home.css';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'TaxActSucks.com',
    url: 'https://taxactsucks.com',
    description: 'A real user\'s experience with TaxAct. Buggy software, hidden fees, paid support, misleading audit protection, and broken import tools. Choose anything but TaxAct.',
  };

  return (
    <>
      <SEOHead
        title="TaxActSucks.com — Don't Make the Same Mistake I Did"
        description="A real user's experience with TaxAct. Buggy software, hidden fees, paid support, misleading audit protection, and broken import tools. Choose anything but TaxAct."
        path="/"
        jsonLd={jsonLd}
      />

      <main>
        <header className="hero">
          <div className="hero-inner">
            <h1>Tax Act Sucks.</h1>
            <p className="hero-sub">
              If you're thinking about using TaxAct for your taxes, do yourself a favor and don't.
              I will never use TaxAct again — for my business or personal taxes — and here's why.
            </p>
          </div>
        </header>

        <div className="content">
          <section className="complaint">
            <div className="complaint-marker">1</div>
            <h2>The Software Is Buggy</h2>
            <p>
              TaxAct's software is riddled with bugs. Pages freeze, data doesn't save correctly,
              and the overall experience feels like software that was rushed out the door without
              proper testing. When you're dealing with something as important as your taxes, the
              last thing you need is unreliable software that you can't trust.
            </p>
          </section>

          <section className="complaint">
            <div className="complaint-marker">2</div>
            <h2>Want Support? Get Ready to Pay.</h2>
            <p>
              If you need any help at all — any support whatsoever — you have to pay for it.
              That's right. You're already paying for the software, and when something goes wrong
              or you have a question, they want more money just to talk to someone. Support should
              be included. Period.
            </p>
          </section>

          <section className="complaint">
            <div className="complaint-marker">3</div>
            <h2>Hidden Fees Everywhere</h2>
            <p>
              TaxAct charges hideous fees for everything. What starts as an affordable-looking
              price quickly balloons as they nickel-and-dime you at every step. State filing,
              add-ons, upgrades — the fees never stop. By the time you're done, you've paid far
              more than you expected.
            </p>
          </section>

          <section className="complaint">
            <div className="complaint-marker">4</div>
            <h2>Audit Protection Is Misleading</h2>
            <p>
              TaxAct sells "audit defense" as part of their offering, but here's what they don't
              make clear: the audit protection isn't actually through TaxAct. It's through a third
              party. They don't tell you this upfront when you're purchasing it. You think you're
              getting protection from the company that prepared your taxes, but you're not.
              That's deceptive.
            </p>
          </section>

          <section className="complaint">
            <div className="complaint-marker">5</div>
            <h2>The Import Tools Are Broken</h2>
            <p>
              TaxAct's form import tools made a bunch of mistakes importing my 1099 forms. These
              weren't from some obscure brokerage — they were from <strong>Fidelity</strong> and
              <strong> Schwab</strong>, two of the largest and most common financial institutions
              in the country. I had to manually go through and correct the errors. If the import
              tool can't handle the basics from major brokerages, what's the point of having it?
            </p>
          </section>

          <section className="complaint">
            <div className="complaint-marker">6</div>
            <h2>You Won't Save Money</h2>
            <p>
              If you think you're going to save money by using TaxAct instead of other platforms,
              you're wrong. Between the hidden fees, the paid support, and the time you'll waste
              dealing with bugs and fixing import errors, any perceived savings disappear fast.
              You're better off paying for a platform that actually works.
            </p>
          </section>

          <section className="bottom-line">
            <h2>The Bottom Line</h2>
            <p>
              I will never use TaxAct again in my life — not for my business, not for my personal
              taxes, not for anything. If you're considering TaxAct, use extreme caution.
            </p>
            <p className="recommendation">
              It is highly recommended to choose anything but TaxAct.
            </p>
          </section>
        </div>

        <footer className="site-footer">
          <div className="footer-inner">
            <p className="footer-disclaimer">
              TaxActSucks.com is an independent consumer opinion site. We are not affiliated with,
              endorsed by, or connected to TaxAct, Inc. All opinions expressed are based on real
              user experiences. TaxAct is a registered trademark of TaxAct, Inc.
            </p>
            <p className="footer-copy">
              &copy; {new Date().getFullYear()} TaxActSucks.com
            </p>
          </div>
        </footer>
      </main>
    </>
  );
}
